import { observer } from 'mobx-react-lite';
import { useNavigate, useParams } from 'react-router-dom';
import classnames from 'classnames';
import ScooterCard from 'components/ScooterCard/ScooterCard';
import Close from 'components/Close/Close';
import ZonesStore from 'stores/Zones';
import styles from './Parking.module.scss';

const Parking = observer(() => {

  const navigate = useNavigate();
  const { id } = useParams();
  const zone = ZonesStore.find(parseInt(id));

  function hoursToHuman(hours) {
    if (!hours) {
      return null;
    }

    if (hours <= 12) {
      return `${hours}AM`;
    } else {
      return `${hours - 12}PM`;
    }
  }

  function renderWorkingHours() {
    if (
      (zone?.open_to === 24 && zone?.open_from === 0) ||
      zone?.open_to === null ||
      zone?.open_from === null ||
      zone?.open_to === undefined ||
      zone?.open_from === undefined
    ) {
      return (
        <span className={classnames(styles.workingHours, styles.workingHoursOpend)}>
          Rent 24/7
        </span>
      );
    }

    const _isOpend = isOpend();
    const content = _isOpend ? 
      `Open, closes ${hoursToHuman(zone.open_to)}`
      :
      `Opens ${hoursToHuman(zone.open_from)}`;
    return (
      <span className={classnames(styles.workingHours, {
        [styles.workingHoursOpend]: isOpend
      } )}>
        {content}
      </span>
    )
  }

  function isOpend() {
    try {
      let now = (new Date()).getHours();
      return zone.open_from <= now && zone.open_to > now;
    } catch (err) {  
      return false;
    }
  }

  if (!zone) {
    navigate(-1);
  }
  

  return (
    <div className={styles.container}>
      <Close to="/" />
      <div className={styles.head}>
        {zone?.photos?.map(photo =>
          <div 
            className={styles.photo} 
            style={{backgroundImage: `url(${photo.thumb_url})`}} 
            key={photo.thumb_url}
          />  
        )}

        <div className={styles.addressWrap}>
          <div className={styles.address}>
            {zone?.address}
          </div>
          <div className={styles.name}>
            {zone?.name}
          </div>
          <div>
            {renderWorkingHours()} {zone?.phone}
          </div>
        </div>
      </div>
      <div className={styles.body}>
        {zone.scooters?.map(scooter =>
          <ScooterCard scooter={scooter} key={scooter.id} />  
        )}
      </div>
    </div>
  );

});

export default Parking;